import React from 'react';
import PropTypes from 'prop-types';
import { SearchableSelectField } from 'common/form/SearchableSelectField';
import { useFeeScheduleProgramOptions } from '../../hooks';

export const ServiceProvidedFilter = ({
  className,
  dataTestId,
  labelClassName,
  onChange,
  value,
}) => {
  const servicesProvided = useFeeScheduleProgramOptions();
  return (
    <SearchableSelectField
      className={className}
      dataTestId={dataTestId}
      label="Service Provided"
      labelClassName={labelClassName}
      onChange={({ value: val }) => onChange(val)}
      options={servicesProvided}
      placeholder="Choose Service Provided"
      value={value ?? ''}
      truncateOptions={false}
      clearable
    />
  );
};

ServiceProvidedFilter.propTypes = {
  className: PropTypes.string,
  dataTestId: PropTypes.string,
  labelClassName: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
};

ServiceProvidedFilter.defaultProps = {
  className: undefined,
  dataTestId: 'invoice-workqueue-filter-service-provided',
  labelClassName: undefined,
  value: undefined,
};
